<template>
    <div class="header">
        <b-row class="w-100">
            <b-col class="d-flex" order="2" order-lg="1" order-xl="1">
                <slot name="left">
                    <div class="go-back-button" @click="onClickGoBackTo">
                        <i class="fas fa-chevron-left mr-1" />
                        <span>Voltar para {{ name }}</span>
                    </div>
                </slot>
            </b-col>
            <b-col
                order="1"
                order-lg="2"
                order-xl="2"
                sm="12"
                lg="8"
                xl="8"
                class="d-flex justify-content-center mb-2 mb-lg-0 mb-xl-0"
            >
                <slot name="center" />
            </b-col>
        </b-row>
    </div>
</template>

<script>
export default {
    name: 'Header',
    props: {
        route: {
            type: String,
            default: '',
        },
        name: {
            type: String,
            default: '',
        },
    },
    methods: {
        onClickGoBackTo() {
            this.$router.push(this.route)
        },
    },
}
</script>
<style lang="sass" scoped>
.header
    display: flex
    align-items: center
    justify-content: space-between
    background-color: white
    width: 100vw
    margin-bottom: 0.5rem
    min-height: 84px
    height: 100%
    padding: 10px
    border-bottom: 1px solid #bec0c0
    box-shadow: 2px 4px 4px rgba(0, 0, 0, 0.25)
    border-bottom-left-radius: 3px
    border-bottom-right-radius: 3px
    .go-back-button
        align-self: center
        cursor: pointer
        font-size: 12px
        color: #6e6e6e
</style>
